import * as z from "zod/v4";

export const acceptAutoClaimsFiling = {
  name: "acceptAutoClaimsFiling" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
